module.exports = __webpack_public_path__ + "static/media/contact-221026.316e47de.png";